import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
interface UseDynamicSizeProps {
  baseWidth: number;
  ref: React.RefObject<HTMLElement | null>;
}
export const useDynamicSize = t0 => {
  const $ = _c(7);
  const {
    baseWidth,
    ref
  } = t0;
  const [width, setWidth] = useState(baseWidth);
  let t1;
  let t2;
  if ($[0] !== baseWidth || $[1] !== ref) {
    t1 = () => {
      const handleResize = () => {
        setWidth(ref.current?.clientWidth || baseWidth);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    t2 = [baseWidth, ref];
    $[0] = baseWidth;
    $[1] = ref;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== baseWidth || $[5] !== width) {
    const dynamicSize = size => `${size * (width / baseWidth)}px`;
    t3 = {
      dynamicSize
    };
    $[4] = baseWidth;
    $[5] = width;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};